import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "../../components/feature/sections/HeroSection";
import TrustBar from "../../components/feature/sections/TrustBar";
import ServicesGrid from "../../components/feature/sections/ServicesGrid";
import AIAnswerBlock from "../../components/feature/sections/AIAnswerBlock";
import ProcessSection from "../../components/feature/sections/ProcessSection";
import WhyChooseUs from "../../components/feature/sections/WhyChooseUs";
import ServiceAreasSection from "../../components/feature/sections/ServiceAreasSection";
import TestimonialsSection from "../../components/feature/sections/TestimonialsSection";
import FAQSection from "../../components/feature/sections/FAQSection";
import FinalCTASection from "../../components/feature/sections/FinalCTASection";
import LeadFormSection from "../../components/feature/sections/LeadFormSection";
import { KRP_SERVICES, KRP_PROCESS, KRP_WHY_CHOOSE } from "../../mocks/krp-data";

const heroContent = {
  badge: "Boca Raton Showroom & South Florida Service Area",
  headline: "Premium Renovations",
  headlineAccent: "Near You.",
  subheadline: "From our Boca Raton design center, KRP serves discerning homeowners across all of South Florida\u2019s most prestigious communities.",
  description: "5250 Town Center Cir #109, Boca Raton, FL 33486 \u00b7 (561) 441-6008 \u00b7 Mon\u2013Fri 10AM\u20135PM",
  primaryCta: "Schedule a Consultation",
  primaryCtaPath: "/locations",
  secondaryCta: "Get Directions",
  secondaryCtaPath: "/locations",
  backgroundImage:
    "https://public.readdy.ai/ai/img_res/48c2b4c099d4ec60d37175f00e85c3d9.jpg",
};

const locationServicesContent = {
  badge: "What We Offer",
  headline: "Complete Renovation Services",
  headlineAccent: "Across South Florida.",
  subtext:
    "KRP brings the same premium standard to every project, regardless of location. From Boca Raton to Fort Lauderdale, every home gets our full design-build expertise.",
  services: KRP_SERVICES.slice(0, 3),
  ctaLabel: "View All Services",
  ctaPath: "/services",
};

const mapBlockContent = {
  badge: "Our Location",
  headline: "Visit Our Boca Raton Design Showroom",
  body:
    "Our flagship showroom is located at Boca Center in Boca Raton, Florida. Step inside to explore our full range of cabinet lines, countertop materials, tile collections, and flooring options. Our design team is available by appointment to guide you through every decision and help you visualize your renovation before a single nail is driven. Whether you\u2019re planning a kitchen remodel in Boca Raton, a bathroom renovation in Delray Beach, or an outdoor kitchen in Palm Beach Gardens, your journey starts here.",
  bullets: [
    "5250 Town Center Cir #109, Boca Raton, FL 33486",
    "Monday \u2013 Friday: 10:00 AM \u2013 5:00 PM (by appointment)",
    "Phone: (561) 441-6008",
    "Email: elliott@kitchenrp.com",
    "Complimentary in-home consultations available throughout South Florida",
  ],
  ctaLabel: "Book Your Showroom Visit",
  ctaPath: "/locations",
  image1:
    "https://readdy.ai/api/search-image?query=luxury%20kitchen%20design%20showroom%20interior%20Boca%20Raton%20Florida%20cabinetry%20display%20warm%20elegant%20professional%20interior%20photography%20ambient%20lighting%20high%20end%20editorial%20studio%20premium%20remodeling%20center&width=800&height=600&seq=7020&orientation=landscape",
  image2:
    "https://readdy.ai/api/search-image?query=luxury%20kitchen%20design%20center%20showroom%20interior%20Boca%20Raton%20display%20countertop%20tile%20selection%20warmly%20lit%20elegant%20modern%20interior%20photography%20premium%20South%20Florida&width=600&height=450&seq=7030&orientation=landscape",
  mapUrl:
    "https://maps.google.com/maps?width=100%25&height=600&hl=en&q=5250+Town+Center+Cir+%23109+Boca+Raton+FL+33486&ie=UTF8&t=&z=15&iwloc=B&output=embed",
};

const processContent = {
  badge: "Our Consultation Process",
  headline: "Starting Your Renovation",
  headlineAccent: "Is Easy.",
  subtext:
    "Whether you\u2019re in Boca Raton, Delray Beach, or anywhere in South Florida, getting started with KRP is simple, fast, and completely obligation-free.",
  steps: KRP_PROCESS,
};

const whyUsContent = {
  badge: "Why KRP",
  headline: "The South Florida Choice for",
  headlineAccent: "Luxury Renovations.",
  subtext:
    "For homeowners across Palm Beach, Broward, and Miami-Dade counties, KRP is the firm they trust most with their most important spaces.",
  reasons: KRP_WHY_CHOOSE,
  ctaLabel: "Start Your Project",
  ctaPath: "/locations",
};

const areasContent = {
  badge: "Service Footprint",
  headline: "We Come to You, Wherever You Are in South Florida",
  body:
    "Our team travels throughout South Florida for in-home consultations. If your city is in Palm Beach, Broward, or Miami-Dade County, we serve you. Contact us to confirm service to your area.",
  ctaLabel: "Schedule In-Home Consultation",
  ctaPath: "/locations",
};

const testimonialsContent = {
  badge: "South Florida Reviews",
  headline: "Trusted From Boca Raton to Broward.",
  subtext: "Hear from homeowners across South Florida who chose KRP for their renovation projects.",
};

const faqContent = {
  badge: "Location Questions",
  headline: "Serving Your Neighborhood",
  subtext: "Common questions from South Florida homeowners about our showroom, service areas, and consultation process.",
  faqs: [
    {
      question: "Where is Kitchen Renovations Perfected located?",
      answer:
        "KRP is located at 5250 Town Center Cir #109, Boca Raton, FL 33486, inside the Boca Center complex. Our showroom is open Monday through Friday, 10:00 AM to 5:00 PM, by appointment. Call (561) 441-6008 to schedule your visit.",
    },
    {
      question: "Do you offer kitchen remodeling in Delray Beach?",
      answer:
        "Yes! Delray Beach is one of our primary service areas. KRP regularly completes kitchen renovations, bathroom remodels, and custom cabinetry projects for Delray Beach homeowners. Contact us at (561) 441-6008 to schedule a free in-home or showroom consultation.",
    },
    {
      question: "Does KRP serve Palm Beach Gardens and Wellington?",
      answer:
        "Absolutely. KRP serves Palm Beach Gardens, Wellington, and all of Palm Beach County. Our design team will travel to your home for a complimentary in-home consultation anywhere within our South Florida service territory.",
    },
    {
      question: "Can KRP renovate kitchens in Fort Lauderdale or Coral Springs?",
      answer:
        "Yes. Our service area extends throughout Broward County, including Fort Lauderdale, Coral Springs, Pompano Beach, Parkland, and Deerfield Beach. Kitchen remodeling and bathroom renovations in Broward County are a regular part of our project portfolio.",
    },
    {
      question: "How do I schedule a consultation with KRP?",
      answer:
        "You can schedule a consultation by calling (561) 441-6008, emailing elliott@kitchenrp.com, or completing the contact form on this page. We offer both in-home consultations and showroom visits at our Boca Raton design center, whichever is more convenient for you.",
    },
    {
      question: "Do you offer kitchen remodeling services in Boynton Beach?",
      answer:
        "Yes. Boynton Beach is within our core South Florida service area. KRP provides full kitchen remodeling, bathroom renovation, and cabinetry services to Boynton Beach homeowners. Reach us at (561) 441-6008 to start planning your renovation.",
    },
  ],
};

const finalCTAContent = {
  badge: "Reserve Your Consultation",
  headline: "Great Design Starts with",
  headlineAccent: "A Conversation.",
  description:
    "Schedule your free consultation today \u2014 in our Boca Raton showroom or in your home, anywhere in South Florida. No pressure, no obligation, just great design.",
  primaryCta: "Book My Free Consultation",
  primaryCtaPath: "/locations",
  secondaryCta: "Call (561) 441-6008",
  secondaryCtaHref: "tel:5614416008",
  backgroundImage:
    "https://readdy.ai/api/search-image?query=elegant%20luxury%20kitchen%20renovation%20complete%20transformation%20bright%20natural%20light%20white%20cabinetry%20marble%20quartz%20countertops%20antique%20brass%20hardware%20statement%20range%20professional%20interior%20photography%20South%20Florida%20luxury%20estate%20warm%20cinematic%20editorial%20architectural&width=1600&height=1000&seq=7040&orientation=landscape",
};

export default function LocationsPage() {
  return (
    <main>
      <Navbar />
      <HeroSection content={heroContent} />
      <TrustBar />
      <ServicesGrid content={locationServicesContent} />
      <AIAnswerBlock content={mapBlockContent} />
      <ProcessSection content={processContent} />
      <WhyChooseUs content={whyUsContent} />
      <ServiceAreasSection content={areasContent} />
      <TestimonialsSection content={testimonialsContent} />
      <FAQSection content={faqContent} />
      <LeadFormSection variant="dark" />
      <FinalCTASection content={finalCTAContent} />
      <Footer />
    </main>
  );
}
